import { MenuService } from './../menu/menu.service';
import { PoNotificationService } from '@po-ui/ng-components';
import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { BehaviorSubject, catchError, filter, finalize, map, Observable, switchMap, take, throwError } from "rxjs";
import { TokenService } from "../token/token.service";
import { UserService } from "../user/user.service";
import { environment } from "../../../environments/environment";

const API = environment.apiUrl;
@Injectable()
export class RequestInterceptor implements HttpInterceptor{

  private isRefreshing = false;
  private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  constructor (private tokenService: TokenService,
               private userService: UserService,
               private http: HttpClient,
               private poNotificationService: PoNotificationService,
               ) {



  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if(this.tokenService.hasToken()) {
      //console.log(req); debug
      const token = this.tokenService.getToken();
      req = req.clone({
            setHeaders: { 'Authorization' : 'Bearer ' + token }
      })

    }

    if (req.method === 'PUT' || req.method === 'PATCH') {
      const url = req.url;
      if (url.includes('/v1/access') && req.body) {
        const body = { ...req.body };
        
        if (body.provisoryTagValidityUtc === '' || body.provisoryTagValidityUtc === null || body.provisoryTagValidityUtc === undefined) {
          body.provisoryTagValidityUtc = null;
        }
        
        if (body.provisoryTag === '') {
          body.provisoryTag = null;
        }
        
        req = req.clone({ body });
      }
    }

    return next.handle(req).pipe(
      catchError(error => {
        if (error.status === 401 && this.tokenService.getRefreshToken()) {
          return this.handle401(req, next);
        }

        // ✅ Verifica se é um ApiMessageDto e exibe toast
        if (error instanceof HttpErrorResponse && error.status === 400 && error.error?.errors) {
              const validationErrors = error.error.errors;
              const detailedMessage = Object.entries(validationErrors)
                .map(([field, messages]) => {
                  const joined = (messages as string[]).join(', ');
                  return `${field}: ${joined}`;
                })
                .join('\n');

              this.poNotificationService.error(detailedMessage);
        }

        return throwError(() => error);
      })
    );
  }

   private handle401(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null); // reseta token

      return this.http.post<any>(API + '/v1/security/refresh-token',
        { refreshToken: this.tokenService.getRefreshToken() })
        .pipe(
          switchMap(response => {
            this.tokenService.setToken(response.accessToken, response.refreshToken);
            this.refreshTokenSubject.next(response.accessToken); // notifica fila

            const clonedReq = req.clone({
              setHeaders: {
                Authorization: `Bearer ${response.accessToken}`
              }
            });

            return next.handle(clonedReq);
          }),
          catchError(err => {
            this.userService.logout();
            return throwError(() => err);
          }),
          finalize(() => this.isRefreshing = false)
        );

    } else {
      // Outras requisições aguardam aqui o novo token
      return this.refreshTokenSubject.pipe(
        filter(token => token !== null), // espera refresh completar
        take(1),
        switchMap(token => {
          const clonedReq = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`
            }
          });
          return next.handle(clonedReq);
        })
      );
    }
  }
}
